module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id",
      "id": "id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.description == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.description),
      expression: "biz.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "description",
      "id": "description"
    },
    domProps: {
      "value": (_vm.biz.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.name == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("编码")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.name),
      expression: "biz.name"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name"
    },
    domProps: {
      "value": (_vm.biz.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("权限")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover table-bordered table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("选中权限"), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "check-all"
    },
    domProps: {
      "checked": _vm.ui.checkedAll ? _vm.checked : ''
    },
    on: {
      "click": _vm.checkAll
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text_overflow"
  }, [_vm._v("权限名称")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.biz.items), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "text_overflow",
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "data-id": item.id
      },
      on: {
        "click": _vm.check
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text_overflow",
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("       ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aaaeaee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/RoleEdit.vue
// module id = 296
// module chunks = 2 3